// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles_inputWrapper__z_yQ9"};